/** One org rollout controls the complete consent flow. */
export const GDPR_CONSENT_COMPLIANCE_FLAG = 'rollout-gdpr-consent-compliance-for-marketing-to-users';
export const GDPR_CONSENT_COMPLIANCE_FLAG_NAME = 'GDPR Consent Compliance for Marketing to users';
//# sourceMappingURL=gdpr-consent.js.map